import PropTypes from 'prop-types';
import HomepageArticle from './homepageArticle';
// import {NavLink} from 'react-router-dom';
import {SmallTitle, MainTitleDark, Button} from 'ui';
import {Container, Slides} from './styles';

const settings = {
  dots: false,
  speed: 500,
  // slidesToShow: 1,
  // slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
  infinite: false,
};

const HomepageArticles = ({posts}) => (
  <Container>
    <SmallTitle style={{marginTop: 0}}>Les articles</SmallTitle>
    <MainTitleDark>Des conseils et des solutions au quotidien</MainTitleDark>
    <Slides {...settings}>
      {posts.map(({id, type}) => (
        <HomepageArticle key={`${id}${type}`} type={type} id={id} />
      ))}
    </Slides>
    <Button style={{margin: 'auto'}} to="/articles">
      En savoir plus
    </Button>
  </Container>
);

HomepageArticles.propTypes = {
  posts: PropTypes.array.isRequired,
};

export default HomepageArticles;
